<ng-template #notIdenticalVersAnsprech>
  <span>
    <ng-container
      *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) as OE; else isEmpty">
      <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                      [showContacts]="false"></app-organization-unit-box-view>
    </ng-container>
    <!--Change Button + OE is Empty-->
    <ng-template #isEmpty>
      {{ getResource('ChangeOE.NotAssigned') }}
    </ng-template>
    <!--Add Button-->
    <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
       style="color: var(--c-dark);text-decoration: none; display:inline"
       (click)="createOE('aue_oeID_Versicherung_AnspPtnr', TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung)">
      {{ getResource('add') }}
    </a>
    <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
       style="color: var(--c-dark);text-decoration: none; display:inline"
       (click)="changeOE('aue_oeID_Versicherung_AnspPtnr', TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung)">
      {{ getResource('change') }}
    </a>
    <!--Delete Button-->
    <a *ngIf="excSecurity.isFeatured('CASEEDIT')
  && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) !== undefined
  && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) !== '00000000-0000-0000-0000-000000000000'
  " href="javascript:void(0)"
       style="color: var(--c-dark);text-decoration: none; display:inline"
       (click)="deleteOE('aue_oeID_Versicherung_AnspPtnr')">
      {{ getResource('remove') }}
    </a>
  </span>
</ng-template>

<div class="content grid-1-auto md3-surface app-pad-top-none" [hidden]="TaskSummary?.taskDetails?.isLoading">
  <!--CONTENT-->
  <div class="content flex-container lh-1-15">
    <!--Header-->
    <div class="flex-row app-space-top cols-3">
      <div class="flex-col md3-card-on-surface">
        <div class="content flex-container lh-1-15">
          <div class="flex-row cols-3">
            <div class="flex-col">
              <h4 *ngIf="!editFunctions.editMode">
                <!-- vorg_enmName_VorgangTyp -->
                {{
                enumSvc.getEnumerationText(
                  TaskSummary?.taskDetails?.data?.vorg_enmName_VorgangTyp,
                  TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangTyp)
                }} - <!-- Auftragsnummer -->
                {{TaskSummary?.taskDetails?.data?.vorgNr}}
              </h4>
              <ng-container *ngIf="editFunctions.editMode">
                <!-- 		              <label>Vorgangstyp</label> -->
                <exg-select [(ngModel)]="selectedVorgangTypIndex"
                            [list]="enumSvc.getEnumerationList(editFunctions?.editTaskModel?.vorg_enmName_VorgangTyp) "
                            listdisplay="enmText"
                            name="vorgTyp"
                ></exg-select>
              </ng-container>
            </div>
            <div class="flex-col spawn">
              <h4 *ngIf="editFunctions.editMode">
                <!-- Auftragsnummer -->
                {{TaskSummary?.taskDetails?.data?.vorgNr}}
              </h4>
            </div>
            <div class="flex-col spawn-reverse">
              <h4>
                {{
                enumSvc.getEnumerationText(
                  TaskSummary?.taskDetails?.data?.vorg_enmName_VorgangStatus,
                  TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus)
                }}
              </h4>
            </div>
          </div>
          <div class="flex-row cols-3">
            <div class="flex-col">
              <p class="typo-small">
                <!--Auftraggeber-->
                <ng-container
                  *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.au_oeID_Auftraggeber) as OE">
                  <img [src]="OE.oeLogo
                          ? (OE.oeLogo.startsWith('data:') ? OE.oeLogo : 'data:image/png;base64,' + OE.oeLogo)
                          : 'assets/images/NoImage.png'"
                       alt="Logo"
                       style="max-width: 150px; max-height: 100px; object-fit: contain; display: block; margin-bottom: 0.25rem;">
                  <app-organization-unit-box-view [data]="OE"
                                                  [showAddress]="0"
                                                  [showContacts]="false"
                  ></app-organization-unit-box-view>
                </ng-container>
              </p>
            </div>
            <div class="flex-col app-space-top">
              <p class="typo-small">
                <ng-container *ngIf="!editFunctions.editMode">
                  <ng-container *ngIf="!TaskSummary?.taskDetails?.data?.vorgBeschreibung">
                    keine Beschreibung vorhanden
                  </ng-container>
                  <ng-container *ngIf="TaskSummary?.taskDetails?.data?.vorgBeschreibung">
                    {{TaskSummary?.taskDetails?.data?.vorgBeschreibung}}
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="editFunctions.editMode">
                  <exg-textarea [(ngModel)]="editFunctions.editTaskModel.vorgBeschreibung"
                                [caption]="enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')"
                                type="text" name="vorgBeschreibung">
                  </exg-textarea>
                </ng-container>
              </p>
            </div>
            <div class="flex-col app-space-top">
              <p class="typo-small">
                <!-- Objektbild -->
                <ng-container>
                  <img alt="thumb" width="200" height="200" class="app-cursor-pointer"
                       [ngClass]="{'placeholder-img': (!TaskSummary?.caseDetails?.data?.aueObjektbild_dokID || TaskSummary?.caseDetails?.data?.aueObjektbild_dokID === '00000000-0000-0000-0000-000000000000')}"
                       src="{{(!TaskSummary?.caseDetails?.data?.aueObjektbild_dokID || TaskSummary?.caseDetails?.data?.aueObjektbild_dokID === '00000000-0000-0000-0000-000000000000')
                           ? 'assets/images/NoImage.png'
                           : excRest.computeUrl(
                           'ImageThumbnailBig',
                            {thumb: 200, dokID: TaskSummary?.caseDetails?.data?.aueObjektbild_dokID})}}"
                       (click)="showObjectImageUpdateModal()"/>

                </ng-container>
              </p>
            </div>
          </div>
          <div class="flex-row cols-3">
            <div class="flex-col">
              <p class="typo-small">
                <!-- Schadennummer -->
                <ng-container
                  *ngIf="TaskSummary?.caseDetails?.data?.aueSchadenNr && TaskSummary?.caseDetails?.data?.aueSchadenNr.length > 0">
                  {{TaskSummary?.caseDetails?.data?.aueSchadenNr}}
                </ng-container>
              </p>
            </div>
            <div class="flex-col">
              <p class="typo-small">

                <!-- Versicherungsnehmer -->
                <ng-container *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_VN) as OE">
                  <app-organization-unit-box-view [data]="OE" [showContacts]="false"
                                                  [showAddress]="0"></app-organization-unit-box-view>
                </ng-container>
              </p>
            </div>
            <div class="flex-col">
              <p class="typo-small">
                <!-- Schadenort -->
                <ng-container *ngIf="TaskSummary?.Schadenort?.data as address">
                  <em>{{address.adrStr}} {{address.adrHNum}} </em>
                  <em>{{address.adrPlz}} {{address.adrOrt}}</em>
                </ng-container>
                <a *ngIf="excSecurity.isFeatured('CASEEDIT')"
                   href="javascript:void(0)"
                   style="color: var(--c-dark);text-decoration: none; display:inline"
                   (click)="changeSchadenort()">
                  {{ getResource('change') }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--MAIN CONTENT & TABS -->
    <div class="flex-row cols-3">
      <!--MAIN-->
      <div class="flex-col flex-col-2">
        <div class="content flex-container lh-1-15" #DivDetails>
          <div class="flex-row" #DivDetails2>
            <div class="flex-col app-space-top md3-card-on-surface">
              <app-exg-tab-v2 #VCrightTabControl
                       [header]="leftTabs">
                <ng-template #pages>
                  <div class="content">
                    <div class="flex-container-v2 lh-1-15 typo-small">
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.VorgangsDetails')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Bearbeiter -->
                            <label>{{enumSvc.getFieldCaption("Vorgang", "vorg_oid_Bearbeiter")}}</label>
                            <ng-container
                              *ngIf="config.getOEByID(TaskSummary?.taskDetails?.data?.vorg_oid_Bearbeiter) as OE">
						                  <span>
						                        <app-organization-unit-box-view [showAddress]="0" [showContacts]="false"
                                                                    [data]="OE">
						                        </app-organization-unit-box-view>
						                    <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="changeEditor()">
						                      {{getResource('change')}}
						                    </a>
						                  </span>
                            </ng-container>
                            <ng-container *ngIf="!TaskSummary?.taskDetails?.data?.vorg_oid_Bearbeiter ||
						                                      TaskSummary?.taskDetails?.data?.vorg_oid_Bearbeiter === '00000000-0000-0000-0000-000000000000'">
						                  <span>
						                      {{getResource('ChangeEditor.NoEditor')}}
                                <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="changeEditor()">
						                      {{getResource('change')}}
						                    </a>
						                  </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <label>Vorgangssubtyp</label>
                            <ng-container *ngIf="!editFunctions.editMode
                              && TaskSummary?.taskDetails?.data?.vorgVorgangSubTyp_enmIdent > 0
                              ">
						                    <span>{{enumSvc.getEnumerationText(
                                  TaskSummary?.taskDetails?.data?.vorgVorgangSubTyp_enmName,
                                  TaskSummary?.taskDetails?.data?.vorgVorgangSubTyp_enmIdent, true)}}</span>
                            </ng-container>
                            <ng-container
                              *ngIf="editFunctions?.editMode && editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName !== ''">
						                    <span>
		                              <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                                    [list]="enumSvc.getEnumerationList(editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName)"
                                                    listdisplay="enmText"
                                                    name="vorgSubTyp"
                                                    label="{{enumSvc.getEnumerationText(editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName, selectedVorgangSubTypIndex)}}"
                                                    maxHeight="250px" position="abovecenter"
                                                    (change)="changeEnum($event)">
		                              </app-exg-dropdown>
		                            </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!--Mandant OKZ-->
                            <label>{{enumSvc.getFieldCaption("Auftrag", "auMdtOKZ")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.auMdtOKZ}}</span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">

                            <!-- Co-Bearbeiter -->
                            <label>{{enumSvc.getFieldCaption("Vorgang", "vorgBearbeiterCo_oeID")}}</label>
                            <ng-container
                              *ngIf="config.getOEByID(TaskSummary?.taskDetails?.data?.vorgBearbeiterCo_oeID) as OE">
						                  <span style="position: relative;">
						                    <app-organization-unit-box-view [showAddress]="0" [showContacts]="false"
                                                                [data]="OE">
						                    </app-organization-unit-box-view>
						                    <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="changeCoEditor()">
						                      {{getResource('change')}}
						                    </a>
						                    <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="deleteCoEditor()">
						                      {{getResource('remove')}}
						                    </a>
						                  </span>
                            </ng-container>
                            <ng-container
                              *ngIf="!TaskSummary?.taskDetails?.data?.vorgBearbeiterCo_oeID ||
						                          TaskSummary?.taskDetails?.data?.vorgBearbeiterCo_oeID == '00000000-0000-0000-0000-000000000000'">
						                  <span>kein Co-Bearbeiter zugewiesen
						                    <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="changeCoEditor()">
							                    {{getResource('change')}}
							                  </a>
						                  </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                      </div>
                      <!-- Schadendaten -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.Schadendaten')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Reserve VU -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserveVU")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueReserveVU | excCurrency: '€'}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Reserve EXCON -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserve")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueReserve | excCurrency: '€'}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!--Schadensumme -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadensumme")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueSchadensumme | excCurrency: '€'}}</span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Regulierungssumme -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueRegulierungsumme")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueRegulierungsumme | excCurrency: '€'}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Einsparbetrag -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueEinsparbetrag")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueEinsparbetrag | excCurrency: '€'}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Regressmöglichkeit -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                              "aueRegressmoeglichkeit_enmIdent")}}</label>
                            <span>{{enumSvc.getEnumerationText(TaskSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmName,
                              TaskSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmIdent)}}</span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Schadenart -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                              "aue_enmIdent_SchadenArt")}}</label>
                            <span>
                                <strong>{{
                                  enumSvc.getEnumerationTextA(
                                    TaskSummary?.caseDetails?.data?.aue_enmName_SchadenArt, TaskSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt
                                  )}} ({{
                                  enumSvc.getEnumerationText(TaskSummary?.caseDetails?.data?.aue_enmName_SchadenArt, TaskSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt
                                  )}})
                                </strong>
                              </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Schadenursache -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                              "aue_enmIdent_SchadenUrsache")}}</label>
                            <span>{{enumSvc.getEnumerationText(TaskSummary?.caseDetails?.data?.aue_enmName_SchadenUrsache,
                              TaskSummary?.caseDetails?.data?.aue_enmIdent_SchadenUrsache)}}</span>
                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                      </div>
                      <!-- Leistungsgegenstand -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.Leistungsgegenstand')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Leistungsgegenstand -->
                            <ng-container *ngIf="TaskSummary?.caseDetails?.data?.aueLeistungsgegenstand">
                              <label></label>
                              <span>
                                <ng-container
                                  *ngFor="let v of TaskSummary?.caseDetails?.data?.aueLeistungsgegenstand.split('||'); let last = last">
                                  {{enumSvc.getEnumerationText('Leistungsgegenstand', v.replaceAll('|', ''))}}
                                  <ng-container *ngIf="!last"><br></ng-container>
                                </ng-container>
                              </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">

                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                      </div>
                      <!-- Sonstiges -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.Sonstiges')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">


                            <!-- Reklamation -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                              "aueReklamation_enmIdent")}}</label>
                            <span>{{enumSvc.getEnumerationText(TaskSummary?.caseDetails?.data?.aueReklamation_enmName,
                              TaskSummary?.caseDetails?.data?.aueReklamation_enmIdent)}}</span>

                          </div>
                          <div class="flex-col-v2">

                            <!-- Abrechnungshinweis -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                              "aueAbrechnungshinweis_enmIdent")}}</label>
                            <span>{{enumSvc.getEnumerationText(TaskSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                              TaskSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent)}}</span>

                          </div>
                          <div class="flex-col-v2">
                            <ng-container *ngIf="TaskSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent && enumSvc.getEnumerationList(enumSvc.getEnumerationItem(TaskSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                                  TaskSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent).enmSelector).length > 0">
                              <!-- Abrechnungshinweis Detail -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                                "aueAbrechnungshinweisSub1_enmIdent")}}</label>
                              <span>{{enumSvc.getEnumerationText(enumSvc.getEnumerationItem(TaskSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                                  TaskSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent).enmSelector,
                                TaskSummary?.caseDetails?.data?.aueAbrechnungshinweisSub1_enmIdent)}}</span>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <!-- Prüfinformation -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2" style="padding-bottom: 0;">
                          <div class="flex-col-v2">
                            <label>{{enumSvc.getFieldCaption('All', '%CKU')}}</label>
                            <span>{{TaskSummary?.taskDetails?.data?.vorgCKU}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <label>{{enumSvc.getFieldCaption('All', '%CKD')}}</label>
                            <span>{{TaskSummary?.taskDetails?.data?.vorgCKD | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content">
                    <div class="flex-container-v2 lh-1-15 typo-small">
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Versicherung.Versicherung')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">

                            <!-- Versicherungsart-->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                              "aue_enmIdent_Versicherungsart")}}
                            </label>
                            <span>{{enumSvc.getEnumerationText(TaskSummary?.caseDetails?.data?.aue_enmName_Versicherungsart,
                              TaskSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart)}}
                              </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ansprechpartner -->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_AnspPtnr")}}</label>
                              <span>
				                          <ng-container
                                    *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) as OE; else isEmpty">
				                            <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                                    [showContacts]="false"></app-organization-unit-box-view>
				                          </ng-container>
                                <!--Change Button + OE is Empty-->
				                          <ng-template #isEmpty>
				                            {{ getResource('ChangeOE.NotAssigned') }}
				                          </ng-template>
                                  <!--Add Button-->
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="createOE('aue_oeID_AnspPtnr')">
                                    {{ getResource('add') }}
                                  </a>
				                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="changeOE('aue_oeID_AnspPtnr')">
				                            {{ getResource('change') }}
				                          </a>
                                <!--Delete Button-->
				                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
				                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== undefined
				                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== '00000000-0000-0000-0000-000000000000'
				                          " href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="deleteOE('aue_oeID_AnspPtnr')">
				                            {{ getResource('remove') }}
				                          </a>
				                        </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Versicherungsnummer -->
                            <label>{{enumSvc.getFieldCaption("Auftrag", "auOKZ")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.auOKZ}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Selbstbehalt-->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSelbstbehalt")}}</label>
                              <span>{{TaskSummary?.caseDetails?.data?.aueSelbstbehalt | excCurrency: '€'}}</span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Versicherungssumme-->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueVersicherungSumme")}}</label>
                              <span>{{TaskSummary?.caseDetails?.data?.aueVersicherungSumme | excCurrency: '€'}}</span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content ">
                    <div class="flex-container-v2 lh-1-15  typo-small">
                      <!-- Ablauf -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Ablauf.Ablauf')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Ortstermin geplant -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtsterminPlan")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueOrtsterminPlan | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Kontaktaufnahme -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueKontaktaufnahme")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueKontaktaufnahme | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ortstermin -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueOrtstermin | excDate}}</span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- 2.Ortstermin -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin2")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueOrtstermin2 | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Weitere Ortstermine -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueWeitereOrtstermine")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueWeitereOrtstermine}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Abschlussdatum -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbschlussdatum")}}</label>
                            <span>{{TaskSummary?.caseDetails?.data?.aueAbschlussdatum | excDate}}</span>
                          </div>
                        </div>
                      </div>
                      <!-- Allgemein -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Ablauf.Vorgang')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Ablauf.Auftrag')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Frist -->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("Vorgang", "vorgFrist")}}</label>
                              <span>{{TaskSummary?.taskDetails?.data?.vorgFrist | excDate}}</span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Auftragsdatum -->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAuftragsdatum")}}</label>
                              <span>{{TaskSummary?.caseDetails?.data?.aueAuftragsdatum | excDate}}</span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Schadendatum -->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenDatum")}}</label>
                              <span>{{TaskSummary?.caseDetails?.data?.aueSchadenDatum | excDate}}</span>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Ansprechpartner -->
                  <div class="content">
                    <div class="flex-container-v2 lh-1-15 typo-small">
                      <!-- Auftraggeber -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{enumSvc.getFieldCaption("Auftrag", "au_oeID_Auftraggeber")}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!--Auftraggeber-->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("Auftrag", "au_oeID_Auftraggeber")}}</label>

                              <span>
                                <ng-container
                                  *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.au_oeID_Auftraggeber) as OE; else isEmpty">
                                  <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                                  [showContacts]="false"></app-organization-unit-box-view>
                                </ng-container>
                                <!--Change Button + OE is Empty-->
                                <ng-template #isEmpty>
                                  {{ getResource('ChangeOE.NotAssigned') }}
                                </ng-template>
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="changeOE('au_oeID_Auftraggeber', '00000000-0000-0000-0000-000000000000', 4, 1)">
                                  {{ getResource('change') }}
                                </a>
                                <!--Delete Button-->
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(TaskSummary?.caseDetails?.data?.au_oeID_Auftraggeber) !== undefined
                      && config.getOEByID(TaskSummary?.caseDetails?.data?.au_oeID_Auftraggeber) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="deleteOE('au_oeID_Auftraggeber')">
                                  {{ getResource('remove') }}
                                </a>
                                </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ansprechpartner -->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("Auftrag", "au_oeId_Ansprechpartner")}}</label>
                              <span>
                          <ng-container
                            *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) as OE; else isEmpty">
                            <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                            [showContacts]="false"></app-organization-unit-box-view>
                          </ng-container>
                                <!--Change Button + OE is Empty-->
                          <ng-template #isEmpty>
                            {{ getResource('ChangeOE.NotAssigned') }}
                          </ng-template>
                          <!--Add Button-->
                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                             style="color: var(--c-dark);text-decoration: none; display:inline"
                             (click)="createOE('au_oeId_Ansprechpartner', TaskSummary?.caseDetails?.data?.au_oeID_Auftraggeber)">
                            {{ getResource('add') }}
                          </a>
                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                             style="color: var(--c-dark);text-decoration: none; display:inline"
                             (click)="changeOE('au_oeId_Ansprechpartner', TaskSummary?.caseDetails?.data?.au_oeID_Auftraggeber)">
                            {{ getResource('change') }}
                          </a>
                                <!--Delete Button-->
                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                          && config.getOEByID(TaskSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) !== undefined
                          && config.getOEByID(TaskSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) !== '00000000-0000-0000-0000-000000000000'
                          " href="javascript:void(0)"
                             style="color: var(--c-dark);text-decoration: none; display:inline"
                             (click)="deleteOE('au_oeId_Ansprechpartner')">
                            {{ getResource('remove') }}
                          </a>
                        </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <label></label>
                          </div>
                        </div>
                      </div>
                      <!-- Versicherung -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>
                              {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_VN")}}
                            </h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Versicherungsnehmer -->
                            <ng-container>
                              <label>
                                {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_VN")}}
                              </label>
                              <span>
	                                <ng-container
                                    *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_VN) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                                    [showContacts]="false"></app-organization-unit-box-view>
	                                </ng-container>
                                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="changeOE('aue_oeID_VN')">
	                                  {{ getResource('change') }}
	                                </a>
                                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_VN) !== undefined
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_VN) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="deleteOE('aue_oeID_VN')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Versicherung -->
                            <ng-container>
                              <label>
                                {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_Versicherung")}}
                              </label>
                              <ng-container *ngIf="TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung ===
	                              TaskSummary?.caseDetails?.data?.au_oeID_Auftraggeber
	                              && TaskSummary?.caseDetails?.data?.au_oeID_Auftraggeber !== '00000000-0000-0000-0000-000000000000'
	                              ; else notIdenticalVersicherung
	                              ">
	                                <span>{{getRessource('ChangeOE.sameAsAG')}}
                                    <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                       style="color: var(--c-dark);text-decoration: none; display:inline"
                                       (click)="changeOE('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', 4, 1)">
	                                    {{getResource('change')}}
	                                  </a>
	                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                       style="color: var(--c-dark);text-decoration: none; display:inline"
                                       (click)="deleteOE('aue_oeID_Versicherung')">
	                                    {{getResource('remove')}}
	                                  </a></span>
                              </ng-container>
                              <ng-template #notIdenticalVersicherung>
	                                <span>
	                                  <ng-container
                                      *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung) as OE; else isEmpty">
	                                    <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                                      [showContacts]="false"></app-organization-unit-box-view>
	                                  </ng-container>
                                    <!--Change Button + OE is Empty-->
	                                  <ng-template #isEmpty>
	                                    {{ getResource('ChangeOE.NotAssigned') }}
	                                  </ng-template>
	                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                       style="color: var(--c-dark);text-decoration: none; display:inline"
                                       (click)="changeOE('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', 4, 1)">
	                                    {{ getResource('change') }}
	                                  </a>
                                    <!--Delete Button-->
	                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung) !== undefined
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
                                       style="color: var(--c-dark);text-decoration: none; display:inline"
                                       (click)="deleteOE('aue_oeID_Versicherung')">
	                                    {{ getResource('remove') }}
	                                  </a>
	                                </span>
                              </ng-template>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Anspruchsteller-->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAnspruchsteller")}}</label>
                              <span>
	                          <ng-container
                              *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) as OE; else isEmpty">
	                            <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                              [showContacts]="false"></app-organization-unit-box-view>
	                          </ng-container>
                                <!--Change Button + OE is Empty-->
	                          <ng-template #isEmpty>
	                            {{ getResource('ChangeOE.NotAssigned') }}
	                          </ng-template>
                            <!--Add Button-->
                            <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="createOE('aue_oeID_Anspruchsteller')">
                              {{ getResource('add') }}
                            </a>
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="changeOE('aue_oeID_Anspruchsteller')">
	                            {{ getResource('change') }}
	                          </a>
                                <!--Delete Button-->
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) !== undefined
	                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) !== '00000000-0000-0000-0000-000000000000'
	                          " href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="deleteOE('aue_oeID_Anspruchsteller')">
	                            {{ getResource('remove') }}
	                          </a>
	                        </span>
                            </ng-container>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Ansprechpartner -->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_AnspPtnr")}}</label>
                              <span>
			                          <ng-container
                                  *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) as OE; else isEmpty">
			                            <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                                  [showContacts]="false"></app-organization-unit-box-view>
			                          </ng-container>
                                <!--Change Button + OE is Empty-->
			                          <ng-template #isEmpty>
			                            {{ getResource('ChangeOE.NotAssigned') }}
			                          </ng-template>
                                <!--Add Button-->
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="createOE('aue_oeID_AnspPtnr')">
                                  {{ getResource('add') }}
                                </a>
			                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="changeOE('aue_oeID_AnspPtnr')">
			                            {{ getResource('change') }}
			                          </a>
                                <!--Delete Button-->
			                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
			                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== undefined
			                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== '00000000-0000-0000-0000-000000000000'
			                          " href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="deleteOE('aue_oeID_AnspPtnr')">
			                            {{ getResource('remove') }}
			                          </a>
			                        </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ansprechpartner-->
                            <ng-container>
                              <label>
                                {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_Versicherung_AnspPtnr")}}
                              </label>
                              <ng-container *ngIf="TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr === TaskSummary?.caseDetails?.data?.au_oeId_Ansprechpartner
                                                  && TaskSummary?.caseDetails?.data?.au_oeId_Ansprechpartner !== '00000000-0000-0000-0000-000000000000'
                                                  ; else notIdenticalVersAnsprech
                              ">
                                <span>
                                  {{getRessource('ChangeOE.sameAsAG')}}
                                  <!--Add Button-->
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="createOE(
                                       'aue_oeID_Versicherung_AnspPtnr',
                                       TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung
                                     )">
                                    {{ getResource('add') }}
                                  </a>
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="changeOE('aue_oeID_Versicherung_AnspPtnr', TaskSummary?.caseDetails?.data?.aue_oeID_Versicherung)">
                                    {{getResource('change')}}
                                  </a>
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="deleteOE('aue_oeID_Versicherung_AnspPtnr')">
                                    {{getResource('remove')}}
                                  </a>
                                </span>
                              </ng-container>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                      <!-- Ansprechpartner -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>
                              {{
                              enumSvc.getEnumerationText(
                                TaskSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion, 0
                              )
                              }}
                            </h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Weiterer Ansprechpartner 1-->
                            <ng-container>
                              <label>
                                {{ enumSvc.getEnumerationText(
                                TaskSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                                TaskSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr1Funktion)
                                }}
                              </label>
                              <span>
	                                <ng-container
                                    *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                                    [showContacts]="false"></app-organization-unit-box-view>
	                                </ng-container>
                                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
                                  <!--Add Button-->
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="createOE('aue_oeID_WAnsprPtnr1')">
                                    {{ getResource('add') }}
                                  </a>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="changeOE('aue_oeID_WAnsprPtnr1')">
	                                  {{ getResource('change') }}
	                                </a>
                                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) !== undefined
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="deleteOE('aue_oeID_WAnsprPtnr1')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Weiterer Ansprechpartner 2 -->
                            <ng-container>
                              <label>
                                {{ enumSvc.getEnumerationText(
                                TaskSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                                TaskSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr2Funktion)
                                }}
                              </label>
                              <span>
	                                <ng-container
                                    *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                                    [showContacts]="false"></app-organization-unit-box-view>
	                                </ng-container>
                                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
                                  <!--Add Button-->
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="createOE('aue_oeID_WAnsprPtnr2')">
                                    {{ getResource('add') }}
                                  </a>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="changeOE('aue_oeID_WAnsprPtnr2')">
	                                  {{ getResource('change') }}
	                                </a>
                                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) !== undefined
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="deleteOE('aue_oeID_WAnsprPtnr2')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Weiterer Ansprechpartner 3 -->
                            <ng-container>
                              <label>
                                {{ enumSvc.getEnumerationText(
                                TaskSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                                TaskSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr3Funktion)
                                }}
                              </label>
                              <span>
	                                <ng-container
                                    *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                                    [showContacts]="false"></app-organization-unit-box-view>
	                                </ng-container>
                                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
                                  <!--Add Button-->
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="createOE('aue_oeID_WAnsprPtnr3')">
                                    {{ getResource('add') }}
                                  </a>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="changeOE('aue_oeID_WAnsprPtnr3')">
	                                  {{ getResource('change') }}
	                                </a>
                                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) !== undefined
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="deleteOE('aue_oeID_WAnsprPtnr3')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
                            </ng-container>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Weiterer Ansprechpartner 4 -->
                            <ng-container>
                              <label>{{ enumSvc.getEnumerationText(
                                TaskSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                                TaskSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr4Funktion)
                                }}
                              </label>
                              <span>
                            <ng-container
                              *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) as OE; else isEmpty">
                              <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                              [showContacts]="false"></app-organization-unit-box-view>
                            </ng-container>
                                <!--Change Button + OE is Empty-->
                            <ng-template #isEmpty>
                              {{ getResource('ChangeOE.NotAssigned') }}
                            </ng-template>
                            <!--Add Button-->
                            <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="createOE('aue_oeID_WAnsprPtnr4')">
                              {{ getResource('add') }}
                            </a>
                            <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="changeOE('aue_oeID_WAnsprPtnr4')">
                              {{ getResource('change') }}
                            </a>
                                <!--Delete Button-->
                            <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                              && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) !== undefined
                              && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) !== '00000000-0000-0000-0000-000000000000'
                              " href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="deleteOE('aue_oeID_WAnsprPtnr4')">
                                {{ getResource('remove') }}
                              </a>
                            </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                      <!-- letzter ... -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Letzter Sachverständiger-->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterSachverstaendiger")}}</label>
                              <span>
	                                <ng-container
                                    *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                                    [showContacts]="false"></app-organization-unit-box-view>
	                                </ng-container>
                                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="changeOE('aue_oeID_letzterSachverstaendiger')">
	                                  {{ getResource('change') }}
	                                </a>
                                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) !== undefined
	                                && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="deleteOE('aue_oeID_letzterSachverstaendiger')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Letzter QS-Prüfer -->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterQSPruefer")}}</label>
                              <span>
	                          <ng-container
                              *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) as OE; else isEmpty">
	                            <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                              [showContacts]="false"></app-organization-unit-box-view>
	                          </ng-container>
                                <!--Change Button + OE is Empty-->
	                          <ng-template #isEmpty>
	                            {{ getResource('ChangeOE.NotAssigned') }}
	                          </ng-template>
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="changeOE('aue_oeID_letzterQSPruefer')">
	                            {{ getResource('change') }}
	                          </a>
                                <!--Delete Button-->
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) !== undefined
	                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) !== '00000000-0000-0000-0000-000000000000'
	                          " href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="deleteOE('aue_oeID_letzterQSPruefer')">
	                            {{ getResource('remove') }}
	                          </a>
	                        </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Letzter Sanierungspartner-->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterSanierungspartner")}}</label>
                              <span>
	                          <ng-container
                              *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) as OE; else isEmpty">
	                            <app-organization-unit-box-view [data]="OE" [showAddress]="0"
                                                              [showContacts]="false"></app-organization-unit-box-view>
	                          </ng-container>
                                <!--Change Button + OE is Empty-->
	                          <ng-template #isEmpty>
	                            {{ getResource('ChangeOE.NotAssigned') }}
	                          </ng-template>
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="changeOE('aue_oeID_letzterSanierungspartner', '00000000-0000-0000-0000-000000000000', 4, 1)">
	                            {{ getResource('change') }}
	                          </a>
                                <!--Delete Button-->
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) !== undefined
	                          && config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) !== '00000000-0000-0000-0000-000000000000'
	                          " href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="deleteOE('aue_oeID_letzterSanierungspartner')">
	                            {{ getResource('remove') }}
	                          </a>
	                        </span>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-exg-tab-v2>
            </div>
          </div>
          <!--ABLAUFPLAN-->
          <div class="flex-row md3-card-on-surface app-space-top"
               #DivSchedule
               *ngIf="excSecurity.isFeatured('SCHEDULEREAD')">
            <div class="flex-col app-space-bottom_1">
              <div class="grid-1-auto">
                <h6>{{getResource("Schedule.Text")}} </h6>
                <div>
                  <button [disabled]="!excSecurity.isFeatured('TASKCONTATTEMPT')"
                          class="md-btn" (click)="openModalContactAttempt()">
                    {{getResource('Workflow.ContactAttempt')}}
                  </button>
                  <button [disabled]="!excSecurity.isFeatured('SCHEDULECREATE')"
                          class="md-btn" (click)="createNewTaskWorklist()">
                    Ablaufpunkt erstellen
                  </button>
                </div>
              </div>
              <ng-container *ngIf="!TaskSummary?.workList?.data || TaskSummary?.workList?.isEmpty">
                <p>Es wurde noch kein Ablaufplan erstellt.</p>
              </ng-container>
              <ng-container *ngIf="TaskSummary?.workList?.data && !TaskSummary?.workList?.isEmpty">
                <div class="app-subarea" style="margin:0 1rem">
                  <exg-data-list #VCAblaufplanItemList
                                 [allowSingleSelection]="false"
                                 (RowDblClick)="showWorklistUpdateModalWithRow($event)"
                                 [displayState]="0"
                                 [rowSource]="TaskSummary?.workList?.data"
                                 selectKey="apiID"
                                 class="list">
                    <ng-template #rowTemplate let-apItem>
                      <div class="list-row list-row-auto-1 app-list">
                        <div [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate > 0"
                             [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate === 0"
                             [class.c-red]="(!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate < 0) || (apItem.apiFreigabe && apItem.DateDiffSoll_IstDate && apItem.DateDiffSoll_IstDate < 0)"
                             [class.app-textdone]="apItem.apiFreigabe"
                             class="typo-center" style="min-width: 70px"
                        >
                          <div class="typo-center">
                            <ng-container *ngIf="!apItem.apiFreigabe">
                              <i class="fa-xl fa-regular fa-calendar-lines"
                                 *ngIf="apItem.DateDiffSoll_PlanDate > 0 ">
                              </i>
                              <i class="fa-xl fa-regular fa-calendar-day"
                                 *ngIf="apItem.DateDiffSoll_PlanDate === 0 ">
                              </i>
                              <i class="fa-xl fa-regular fa-calendar-exclamation"
                                 *ngIf="apItem.DateDiffSoll_PlanDate < 0 ">
                              </i>
                            </ng-container>
                            <ng-container *ngIf="apItem.apiFreigabe">
                              <i class="fa-xl fa-regular fa-calendar"
                                 *ngIf="apItem.DateDiffSoll_IstDate >= 0">
                              </i>
                              <i class="fa-xl fa-regular fa-calendar-exclamation"
                                 *ngIf="apItem.DateDiffSoll_IstDate < 0">
                              </i>
                            </ng-container>
                          </div>
                          <div class="typo-small app-space-top">
                            <ng-container *ngIf="!apItem.apiFreigabe">
                              {{
                              apItem.DateDiffSoll_PlanDate === 0 ? 'Heute' :
                                apItem.DateDiffSoll_PlanDate > 0 ? 'in ' + apItem.DateDiffSoll_PlanDate + ' T.' :
                                  apItem.DateDiffSoll_PlanDate < 0 ? 'vor ' + apItem.DateDiffSoll_PlanDate + ' T.' : ''
                              }}
                            </ng-container>
                            <ng-container *ngIf="apItem.apiFreigabe && apItem.DateDiffSoll_IstDate < 0">
                              {{
                              apItem.DateDiffSoll_IstDate < 0 ? 'übers. ' + apItem.DateDiffSoll_IstDate + ' T.' : ''
                              }}
                            </ng-container>
                          </div>
                        </div>
                        <div class="typo-small">
                          <div class="grid-1-auto">
                            <div class="typo-container-s-s-q span-2 app-typo-tablecell">
                                <span class="typo-center"
                                      style="text-align: left;">
                                </span>
                              <span>
                                  <i class="search-filter-action disabled fa-clipboard-check"
                                     flow="right"
                                     [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiFreigabe')"
                                     [class.app-fa-duotone-green]="apItem.apiFreigabe"
                                     [class.fa-duotone]="apItem.apiFreigabe"
                                     [class.fa-light]="!apItem.apiFreigabe">
                                  </i>
                                  <ng-container *ngIf="excSecurity.isFeatured('SCHEDULEMGMT')">
                                    <i class="search-filter-action disabled fa-magnifying-glass"
                                       flow="right"
                                       [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiPruefen')"
                                       [class.fa-duotone]="apItem.apiPruefen"
                                       [class.fa-light]="!apItem.apiPruefen">
                                    </i>
                                    <i class="search-filter-action disabled fa-monitor-waveform"
                                       flow="right"
                                       [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiMonitoring')"
                                       [class.fa-duotone]="apItem.apiMonitoring"
                                       [class.fa-light]="!apItem.apiMonitoring">
                                    </i>
				                            <i class="search-filter-action disabled fa-duotone fa-list-radio"
                                       flow="right"
                                       [tooltip]="getRessource('Ablaufplan.isapiCustom')"
                                       *ngIf="apItem.apiCustom">
					                          </i>
                                    <i class="search-filter-action disabled fa-user-pen fa-duotone"
                                       flow="right"
                                       [tooltip]="getRessource('Ablaufplan.isNotapiCustom')"
                                       *ngIf="!apItem.apiCustom">
						                        </i>
                                  </ng-container>
                                </span>
                              <q></q>
                              <ng-container *ngIf="apItem.apiBezeichnung && apItem?.apiBezeichnung.length > 0">
                                  <span [class.app-textdone]="apItem.apiFreigabe">
                                    {{enumSvc.getFieldCaption("Ablaufplan", 'apiBezeichnung')}}
                                  </span>
                                <span [class.app-textdone]="apItem.apiFreigabe">{{apItem.apiBezeichnung}}</span>
                                <q></q>
                              </ng-container>
                              <span [class.app-textdone]="apItem.apiFreigabe">
                                  {{enumSvc.getFieldCaption("Ablaufplan", 'apiAblaufplanKategorie_enmIdent')}}
                                </span>
                              <span [class.app-textdone]="apItem.apiFreigabe">
                                  {{enumSvc.getEnumerationText('AblaufplanKategorie', apItem.apiAblaufplanKategorie_enmIdent)}}
                                </span>
                              <q></q>
                              <!-- apiSollDatum -->
                              <span [class.app-textdone]="apItem.apiFreigabe"
                                    [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSollDate > 0"
                                    [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSollDate === 0"
                                    [class.c-red]="(!apItem.apiFreigabe && (apItem.DateDiffSollDate <= 1)) || (apItem.apiFreigabe && apItem.DateDiffSoll_IstDate && apItem.DateDiffSoll_IstDate < 0)">
                                      {{enumSvc.getFieldCaption("Ablaufplan", 'apiSollDatum')}}
                                </span>
                              <span [class.app-textdone]="apItem.apiFreigabe"
                                    [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSollDate > 0"
                                    [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSollDate === 0"
                                    [class.c-red]="(!apItem.apiFreigabe && (apItem.DateDiffSollDate <= 1)) || (apItem.apiFreigabe && apItem.DateDiffSoll_IstDate && apItem.DateDiffSoll_IstDate < 0)">
                                    {{apItem.apiSollDatum | excDate: 'dd.MM.yyyy HH:mm'}}
                                </span>
                              <q></q>
                              <!-- apiPlanDatum -->
                              <ng-container *ngIf="apItem.apiPlanDatum">
												          <span [class.app-textdone]="apItem.apiFreigabe"
                                        [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate > 0"
                                        [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate === 0"
                                        [class.c-red]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate < 0">
													          {{enumSvc.getFieldCaption("Ablaufplan", 'apiPlanDatum')}}
	                                </span>
                                <span [class.app-textdone]="apItem.apiFreigabe"
                                      [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate > 0"
                                      [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate === 0"
                                      [class.c-red]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate < 0">
	                                    {{apItem.apiPlanDatum | excDate: 'dd.MM.yyyy HH:mm'}}
	                                </span>
                                <q></q>
                              </ng-container>
                              <!-- apiIstDatum -->
                              <ng-container *ngIf="apItem.apiIstDatum">
                                  <span [class.app-textdone]="apItem.apiFreigabe"
                                        [class.c-red]="apItem.apiFreigabe && apItem.DateDiffSoll_IstDate < 0">
                                    {{enumSvc.getFieldCaption("Ablaufplan", 'apiIstDatum')}}
                                  </span>
                                <span [class.app-textdone]="apItem.apiFreigabe"
                                      [class.c-red]="apItem.apiFreigabe && apItem.DateDiffSoll_IstDate < 0">
                                      {{apItem.apiIstDatum | excDate: 'dd.MM.yyyy HH:mm'}}
                                  </span>
                                <q></q>
                              </ng-container>
                              <ng-container *ngIf="apItem.apiKommentar && apItem.apiKommentar.length >= 0">
                                  <span class="typo-small" [class.app-textdone]="apItem.apiFreigabe">
                                    {{enumSvc.getFieldCaption("Ablaufplan", 'apiKommentar')}}
                                  </span>
                                <span class="typo-small" style="white-space: unset"
                                      [class.app-textdone]="apItem.apiFreigabe">
                                      {{apItem.apiKommentar}}
                                  </span>
                                <q></q>
                              </ng-container>
                            </div>
                            <div class="list-metadata ">
                              <div class="typo-right">{{apItem.apiLCU ? apItem.apiLCU : apItem.apiCRU}}</div>
                              <div
                                class="typo-right">{{(apItem.apiLCD ? apItem.apiLCD : apItem.apiCRD) | excDate: 'dd.MM.yy HH:mm'}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </exg-data-list>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <!--TABS-->
      <div class="flex-col">
        <div class="content flex-container lh-1-15">
          <div class="flex-row">
            <div class="flex-col app-space-top md3-card-on-surface" #DivVerlauf
                 style="height: 100%; min-height: 480px">
              <app-exg-tab-v2 #VCrightTabControl [header]="rightTabs">
                <ng-template #pages>
                  <!--1 - Anhänge -->
                  <div class="content" style="min-height: 480px">
                    <app-tab-task-attachment
                      *ngIf="!TaskSummary?.taskDetails?.isLoading"
                      [entityID]="TaskSummary?.ID"
                      [SummaryAttachmentTable]="TaskSummary?.attachmentJagTable"
                      [ConfigAttachmentTable]="config.attachmentJagTable"
                      [AttachmentFolderStates]="openAttachmentFolder"
                      (attachmentFolderStatesChange)="saveAttachmentFolderStates($event)"
                      [Events]="Events"
                      [auftragData]="TaskSummary?.caseDetails?.data"
                      [taskList]="TaskSummary?.taskList.data">
                    </app-tab-task-attachment>
                  </div>
                  <!--2 - Report Tab -->
                  <div class="content" style="min-height: 480px">
                    <app-tab-report-details
                      *ngIf="!TaskSummary.isLoading"
                      [entityID]="TaskSummary?.ID"
                      [SummaryCalculationTable]="TaskSummary?.calculationVersion.data"
                      [SummaryQuestionnaireTable]="TaskSummary?.questionnaireVersion.data"
                      [SummaryPhotoDocumentationTable]="TaskSummary?.photoDocumentation.data"
                      [ReportFolderStates]="openReportFolder"
                      (reportFolderStatesChange)="saveReportFolderStates($event)"
                      [Events]="Events"
                    >
                    </app-tab-report-details>
                  </div>
                  <!--3 - Formular -->
	                <div class="content" style="min-height: 480px">
		                <app-tab-task-formular
			                *ngIf="!TaskSummary?.taskDetails?.isLoading"
			                [formularVersion]="TaskSummary?.formularVersion"
			                [Events]="Events">
		                </app-tab-task-formular>
	                </div>
                  <!--4 - Receipt -->
                  <div class="content" style="min-height: 480px">
                    <app-tab-task-receipt
                      *ngIf="!TaskSummary?.taskDetails?.isLoading"
                      [ConfigReceiptTable]="config.receiptList"
                      [SummaryReceiptTable]="TaskSummary?.receiptList"
                      [Events]="Events">
                    </app-tab-task-receipt>
                  </div>
                  <!--5 - Leistungsaufstellungen -->
                  <div class="content" style="min-height: 480px">
                    <app-tab-task-leistung
                      *ngIf="!TaskSummary?.taskDetails?.isLoading"
                      [ConfigLeistungTable]="config.leistungList"
                      [SummaryLeistungTable]="TaskSummary?.leistungList"
                      [Events]="Events">
                    </app-tab-task-leistung>
                  </div>
                  <!--6 - Fragen-->
                  <div class="content" style="min-height: 480px">
                    <div class="layout-1-auto">
                      <div class="content app-subarea">
                        <exg-data-list [allowSingleSelection]="false"
                                       [rowSource]="TaskSummary?.dialogueQuestions?.data"
                                       selectKey="dfID">
                          <ng-template #rowTemplate let-row>
                            <div class="list-row list-single-line-auto-1 typo-small">
                              <div><strong>{{row.dfText}}</strong></div>
                              <div class="list-secondary-text"
                                   *ngIf="row.deValue && row.deValue.length > 0">{{row.deValue}}</div>
                              <div class="list-secondary-text" style="font-style: italic"
                                   *ngIf="!row.deValue || row.deValue.length === 0">
                                &lt;&lt;{{getRessource('noneMessages.noAnswerer')}}&gt;&gt;
                              </div>
                            </div>
                          </ng-template>
                        </exg-data-list>
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                  <!--7 - Verlauf -->
                  <div class="content" style="min-height: 480px">
                    <app-tab-task-flowtable
                      [ConfigFlowTable]="config.flowTable"
                      [SummaryFlowTable]="TaskSummary?.flowTable"
                      [Events]="Events">
                    </app-tab-task-flowtable>
                  </div>
                  <!--8 - Vorgänge-->
                  <div class="content" style="min-height: 480px">
                    <exg-data-list #VCVorganglist
                                   selectKey="vorgID"
                                   [displayState]="TaskSummary?.taskList?.data && TaskSummary?.taskList?.data.length > 0 ? 0 : 2"
                                   [rowSource]="TaskSummary?.taskList.data"
                                   [selectSourceRows]="config.taskList.selectedObjects"
                                   (RowChange)="config.taskList.rowChange($event)"
                                   (ItemSelect)="config.taskList.itemSelect($event)">
                      <ng-template #rowTemplate let-task>
                        <div class="list-row-auto-1"
                             (dblclick)="onClickOpenTaskCheckview(task)"
                             [class.active]="config.taskList.selectedObjects[0] === task">
                          <div></div>
                          <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                            <div class="list-metadata" style="margin-left:0">
                              <div>
                                {{enumSvc.getEnumerationText('VorgangStatus', task.vorg_enmIdent_VorgangStatus)}} -
                                {{enumSvc.getEnumerationText('VorgangTyp', task.vorg_enmIdent_VorgangTyp)}}
                              </div>
                              <div>Auftraggeber: {{task.auAuftraggeberShort}}
                                Schadenart: {{enumSvc.getEnumerationText('Schadenart', task.aue_enmIdent_SchadenArt)}}</div>
                            </div>
                            <div class="list-metadata ">
                              <div
                                class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}
                              </div>
                            </div>
                            <div style="height: 30px">
                                <span class="typo-center">
                                  <span [tooltip]="'Nicht Geprüft'" flow="right">
                                    <i class="fa-solid fa-xmark c-red" style="font-size: 14px"
                                       *ngIf="!task.vorgCKD"></i>
                                  </span>
                                  <span [tooltip]="'Geprüft'" flow="right">
                                    <i class="fa-solid fa-check c-green" style="font-size: 14px"
                                       *ngIf="task.vorgCKD"></i>
                                  </span>
                                </span>
                              <span class="app-space-left">
                                  <strong>{{task.vorgNr}}</strong>
                                </span>
                            </div>
                            <div class="typo-right">
                              <i class="search-action fa-regular fa-chevron-right"
                                 *ngIf="config.taskList.selectedObjects[0] === task"
                                 (click)="onClickOpenTaskCheckview(task)">
                              </i>
                            </div>
                            <div class="span-2 typo-container-s-s-q app-space-left_none">
                              <ng-container *ngIf="task.vorgBeschreibung && task.vorgBeschreibung.length > 0">
                                  <span style="width: 148px">
                                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')}}:
                                  </span>
                                <span class="typo-left"
                                      *ngIf="config.taskList.selectedObjects[0] === task">
                                    {{task.vorgBeschreibung}}
                                  </span>
                                <span class="typo-left"
                                      *ngIf="config.taskList.selectedObjects[0] !== task">
                                    {{task.vorgBeschreibung.slice(0, 48)}}
                                  {{task.vorgBeschreibung.length > 48 ? '...' : ''}}
                                  </span>
                                <q></q>
                              </ng-container>
                              <ng-container *ngIf="task.vorgBearbeiter && task.vorgBearbeiter.length > 0">
                                  <span style="width: 148px">
                                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBearbeiter')}}:
                                  </span>
                                <span class="typo-left">
                                    {{task.vorgBearbeiter}}
                                  </span>
                                <q></q>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </exg-data-list>
                  </div>
                </ng-template>
              </app-exg-tab-v2>
            </div>
          </div>
          <div class="flex-row md3-card-on-surface app-space-top">
            <div class="flex-col app-space-bottom_1">
              <div class="grid-1-auto">
                <h6>{{getResource('TabTitle.Details.ExternalMailboxJournal')}} </h6>
              </div>
              <ng-container *ngIf="!TaskSummary?.journalMail?.data || TaskSummary?.journalMail?.isEmpty">
                <p>Es gibt keine externen Mails im Journal.</p>
              </ng-container>
              <ng-container *ngIf="TaskSummary?.journalMail?.data && !TaskSummary?.journalMail?.isEmpty">
                <div class="app-subarea" style="margin:0 1rem">
                  <exg-data-list #VCJournalMailList
                                 [allowSingleSelection]="false"
                                 (RowDblClick)="onDblClickJournalMail($event)"
                                 [displayState]="0"
                                 [rowSource]="TaskSummary?.journalMail?.data"
                                 selectKey="jmID"
                                 class="list">
                    <ng-template #rowTemplate let-jmItem>
                      <div class="list-row-auto-1">
                        <div></div>
                        <div class="layout-auto-1-auto-grid-1-auto grid typo-small" style="cursor: pointer">
                          <div class="list-metadata" style="margin-left:0">
                            <ng-container *ngIf="false">{{jmItem.jmFrom}} > {{jmItem.jmTo}}{{jmItem.jmCc.length > 0 ? ', ' + jmItem.jmCc : ''}}</ng-container>
                            <div>
                              Von: {{jmItem.jmFrom}}
                            </div>
                            <div>
                              An: {{jmItem.jmTo}}
                            </div>
                            <div *ngIf="jmItem.jmCc.length > 0">
                              Cc: {{ jmItem.jmCc}}
                            </div>
                          </div>
                          <div class="list-metadata ">
                            <div
                              class="typo-right">{{jmItem.jmCRD | excDate: 'Globals.DateTimeFormatShort'}}
                            </div>
                          </div>
                          <div style="height: 30px; text-overflow:ellipsis; white-space: nowrap; overflow: hidden ">
                                <span>
                                  <strong>{{jmItem.jmSubject}}</strong>
                                </span>
                          </div>
                          <div class="typo-right">
                            <ng-container>
                              <span>{{getJournalMailAttachment(jmItem).length}}</span>
                            </ng-container>
                            <ng-container>
                              <i class="fa-light fa-paperclip"></i>
                            </ng-container>
                          </div>
                          <div class="span-2 list-metadata " style="margin-left:0">
                                <span>
                                  {{jmItem.jmBody}}
                                </span>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </exg-data-list>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--ICON BAR RIGHT-->
  <div class="md3-card-on-surface app-space-top app-height-auto app-drawer" style="overflow: visible">
    <i class="disabled search-filter-action"></i>
    <i class="search-filter-seperator"></i>
    <ng-container *ngIf="excSecurity.isFeatured('CASEREAD')">
      <i *ngIf="excSecurity.isFeatured('CASEREAD')"
         (click)="openCase()"
         class="search-filter-action fal fa-folder"
         [tooltip]="getRessource('tooltip.openCase')"
         flow="left"></i>
      <i class="search-filter-seperator"></i>
    </ng-container>
    <i (click)="openWorkspace()"
       class="search-filter-action fal fa-business-time"
       [tooltip]="getRessource('tooltip.openWorkspace')" flow="left">
    </i>
    <i class="search-filter-seperator"></i>
    <app-exg-dropdown>
      <ng-template #hostTemplate>
        <i class="search-filter-action fal fa-ellipsis-v"
           [class.disabled]="!isWorkflowActive()"
           [tooltip]="!isWorkflowActive()
           ? getRessource('noneMessages.noWorkflow')
           : getRessource('tooltip.WorkflowMenu')" flow="left">
        </i>
      </ng-template>
      <ng-template #contentTemplate let-popup>
        <div *ngFor="let row of workFlowMenu">
          <div class="list-row list-single-line  typo-small" style="cursor:pointer" (click)="row.click(); popup.close()"
               *ngIf="row.visible">{{row.caption}}</div>
        </div>
      </ng-template>
    </app-exg-dropdown>
    <!--Editing Buttons-->
    <i class="search-filter-action fal fa-pencil"
       *ngIf="!editFunctions.editMode && excSecurity.isFeatured('TASKEDIT')"
       (click)="editFunctions.enterEditMode(this.TaskSummary.taskDetails.data)"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Vorgang bearbeiten'"
       flow="left"></i>
    <i class="search-filter-action fal fa-floppy-disk"
       *ngIf="editFunctions.editMode && excSecurity.isFeatured('TASKEDIT')"
       (click)="this.saveEdit(this.TaskSummary.taskDetails.data)"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Bearbeitung speichern'"
       flow="left"></i>
    <i class="search-filter-action fal fa-xmark"
       (click)="editFunctions.cancelEdit(this.TaskSummary.taskDetails.data);"
       *ngIf="editFunctions.editMode && excSecurity.isFeatured('TASKEDIT')"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Bearbeitung abbrechen'"
       flow="left"
    ></i>
    <i class="search-filter-seperator"></i>
    <app-exg-dropdown position="underleft"
                      [adaptiveHeightActive]="true"
                      [adaptiveHeightOffset]="400"
                      [disabled]="TaskSummary?.isLoading">
      <ng-template #hostTemplate>
        <i class="search-filter-action fal fa-plus"
           [tooltip]="getGlobal('Add')" flow="left"
           [class.disabled]="TaskSummary?.isLoading"></i>
      </ng-template>
      <ng-template #contentTemplate let-popup>
        <div class="content" style="max-height: 500px">
          <div (click)="config.newReport(); popup.close();"
               *ngIf="excSecurity.isFeatured('REPORTCREATE')"
               class="md-menu-item">
            Bericht
          </div>
          <div (click)="config.newServiceRecord(); popup.close();"
               *ngIf="excSecurity.isFeatured('DEVELOPMENT')"
               class="md-menu-item">
            Leistungsaufstellung
          </div>
          <!-- Questionnaire Creation -->
          <ng-container *ngIf="TaskSummary && TaskSummary.questionnaireConfigurations && TaskSummary.questionnaireConfigurations.data
            && TaskSummary.questionnaireConfigurations.data.length > 0
            && excSecurity.isFeatured('RQUESTVCREATE')">
            <ng-container
              *ngIf="TaskSummary?.questionnaireConfigurations?.data?.length === 1; else multipleConfigElements">
              <ng-container *ngFor="let row of TaskSummary?.questionnaireConfigurations?.data">
                <div (click)="createNewQuestionnaireVersion(row.qcnfID);popup.close();"
                     class="md-menu-item">Fragebogen {{row.qcfgName}}</div>
              </ng-container>
            </ng-container>
            <ng-template #multipleConfigElements>
              <app-exg-dropdown [adaptiveHeightActive]="true">
                <ng-template #hostTemplate>
                  <div class="md-menu-item"
                       *ngIf="excSecurity.isFeatured('RQUESTVCREATE')">
                    Fragebögen...
                  </div>
                </ng-template>
                <ng-template #contentTemplate let-popup>
                  <ng-container *ngFor="let row of TaskSummary?.questionnaireConfigurations?.data">
                    <div (click)="createNewQuestionnaireVersion(row.qcnfID);popup.close();"
                         class="md-menu-item typo-left">{{row.qcfgName}}</div>
                  </ng-container>
                </ng-template>
              </app-exg-dropdown>
            </ng-template>
          </ng-container>
          <!-- Calculation Creation -->
          <ng-container *ngIf="TaskSummary && TaskSummary.calculationTemplates && TaskSummary.calculationTemplates.data
            && TaskSummary.calculationTemplates.data.length > 0
            && excSecurity.isFeatured('RCALCVCREATE')">
            <ng-container *ngIf="TaskSummary?.calculationTemplates?.data?.length === 1; else multipleTemplates">
              <ng-container *ngFor="let row of TaskSummary?.calculationTemplates?.data">
                <div (click)="createNewCalculationVersion(row);popup.close();"
                     class="md-menu-item">Kalkulation {{row.ctName}}</div>
              </ng-container>
            </ng-container>
            <ng-template #multipleTemplates>
              <app-exg-dropdown [adaptiveHeightActive]="true">
                <ng-template #hostTemplate>
                  <div class="md-menu-item"
                       *ngIf="excSecurity.isFeatured('RCALCVCREATE')">
                    Kalkulation...
                  </div>
                </ng-template>
                <ng-template #contentTemplate let-popup>
                  <ng-container *ngFor="let row of TaskSummary?.calculationTemplates?.data">
                    <div (click)="createNewCalculationVersion(row);popup.close();"
                         class="md-menu-item typo-left">{{row.ctName}}</div>
                  </ng-container>
                </ng-template>
              </app-exg-dropdown>
            </ng-template>
          </ng-container>
          <!-- Formular Creation -->
          <ng-container *ngIf="TaskSummary && TaskSummary.formularTemplates && TaskSummary.formularTemplates.data
											            && TaskSummary.formularTemplates.data.length > 0
											            && excSecurity.isFeatured('FORMVCREATE')">
            <ng-container *ngIf="TaskSummary?.formularTemplates?.data?.length === 1; else multipleTemplates">
              <ng-container *ngFor="let row of TaskSummary?.formularTemplates?.data">
                <div (click)="createNewFormularVersion(row);popup.close();"
                     class="md-menu-item">Formular {{row.frmTName}}</div>
              </ng-container>
            </ng-container>
            <ng-template #multipleTemplates>
              <app-exg-dropdown  [adaptiveHeightActive]="true">
                <ng-template #hostTemplate>
                  <div class="md-menu-item"
                       *ngIf="excSecurity.isFeatured('FORMVCREATE')">
                    Formularwesen (neu)
                  </div>
                </ng-template>
                <ng-template #contentTemplate let-popup>
                  <ng-container *ngFor="let row of TaskSummary?.formularTemplates?.data">
                    <div (click)="createNewFormularVersion(row);popup.close();"
                         class="md-menu-item typo-left">{{row.frmTName}}</div>
                  </ng-container>
                </ng-template>
              </app-exg-dropdown>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="excSecurity.isFeatured('MSGCREATE')">
            <div *ngIf="!(TaskSummary?.defaultMessages?.data.length > 0)"
                 (click)="config.newMessage(); popup.close();"
                 class="md-menu-item">
              Nachricht
            </div>
            <app-exg-dropdown *ngIf="TaskSummary?.defaultMessages?.data.length > 0" [adaptiveHeightActive]="true">
              <ng-template #hostTemplate>
                <div class="md-menu-item">Nachricht...</div>
              </ng-template>
              <ng-template #contentTemplate let-popup>
                <div (click)="config.newMessage();popup.close();" class="md-menu-item typo-left">Leere Nachricht</div>
                <ng-container>
                  <ng-container *ngFor="let row of TaskSummary?.defaultMessages?.data">
                    <div (click)="config.newDefaultMessage(row.dmsgID);popup.close();"
                         class="md-menu-item typo-left">{{row.dmsgBezeichnung}}</div>
                  </ng-container>
                </ng-container>
              </ng-template>
            </app-exg-dropdown>
          </ng-container>
          <div *ngIf="excSecurity.isFeatured('NTZEDIT')"
               (click)="config.newNote();popup.close();" class="md-menu-item">
            Notiz
          </div>
          <div (click)="config.showUploadReceiptModal(); popup.close();"
               *ngIf="excSecurity.isFeatured('RECEIPTCREATE')"
               class="md-menu-item">
            {{getGlobal('Receipt')}}
          </div>
          <div (click)="config.showUploadStatementModal(); popup.close();"
               *ngIf="excSecurity.isFeatured('STATEMENTCREATE')"
               class="md-menu-item">
            {{getGlobal('ReceiptStatement')}}
          </div>
          <div (click)="config.showAttachmentUploadModal(); popup.close();"
               *ngIf="excSecurity.isFeatured('DOCUMENTCREATE')"
               class="md-menu-item">
            Anlage
          </div>
          <app-exg-dropdown *ngIf="TaskSummary?.documentTemplate.data.length > 0" [adaptiveHeightActive]="true">
            <ng-template #hostTemplate>
              <div class="md-menu-item"
                   *ngIf="excSecurity.isFeatured('TASKFORMCREATE')">
                Formulare (alt)
              </div>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <ng-container *ngFor="let row of TaskSummary?.documentTemplate?.data">
                <div (click)="config.documentTemplateDownload(row.dotID); popup.close();"
                     class="md-menu-item typo-left">{{row.dotName}}</div>
              </ng-container>
            </ng-template>
          </app-exg-dropdown>
          <div (click)="addVNData(); popup.close();"
               *ngIf="excSecurity.isFeatured('CRMVNADD')
                && TaskSummary?.caseDetails?.data?.aue_oeID_VN
                && TaskSummary?.caseDetails?.data?.aue_oeID_VN !== '00000000-0000-0000-0000-000000000000'"
               class="md-menu-item">
            Daten hinzufügen
          </div>
        </div>
      </ng-template>
    </app-exg-dropdown>
    <i class="search-filter-action fa-light fa-folders"
       *ngIf="excSecurity.isFeatured('DOCUMENTMGMT')"
       (click)="openFileOverview()"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Dokumenten Manager'"
       flow="left"></i>
    <i class="search-filter-action fa-light fa-video-arrow-up-right"
       *ngIf="excSecurity.isFeatured('DEVELOPMENT')"
       (click)="openVideoTool()"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Video Tool starten'"
       flow="left"></i>
    <i class="search-filter-action fa-light fa-screwdriver-wrench"
       *ngIf="excSecurity.isFeatured('REPORTBUILDER')"
       (click)="openReportBuilderOverlay()"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Neuen Report erstellen'"
       flow="left">
    </i>
    <i class="search-filter-action fal fa-image"
       *ngIf="excSecurity.isFeatured('DOKVIEWER')"
       (click)="config.showAttachmentPreview()"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Anlagen ansehen'"
       flow="left"></i>
    <i class="search-filter-action fal fa-file-image"
       [tooltip]="'Neue Bilddokumentation'" flow="left"
       [class.disabled]="TaskSummary?.isLoading"
       (click)="createNewPhotoDoc()"
       *ngIf="excSecurity.isFeatured('RPHOTOCREATE')"
    ></i>
    <i class="search-filter-seperator"></i>
    <i (click)="config.showHistory()" class="search-filter-action {{getResource('Tabs.History.Icon')}}"
       *ngIf="excSecurity.isFeatured('TASKREAD')"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Historie'" flow="left"></i>
    <i class="search-filter-action fal fa-list-timeline"
       *ngIf="excSecurity.isFeatured('HISTORYEXTREAD')"
       (click)="OpenDetailHistoryModal()"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'History'"
       flow="left"></i>
    <i class="search-filter-seperator"></i>
    <ng-container *ngIf="VCrightTabControl.selectedtab === 3
                      && rightDrawerVisible
                      && !TaskSummary?.isLoading">
      <app-exg-dropdown>
        <ng-template #hostTemplate>
          <i class="fal fa-file-chart-line search-filter-action"
             [class.disabled]="!(TaskSummary?.receiptList?.data
                                 && TaskSummary.receiptList.data.length > 0
                                 && !config.receiptList.isLoading)"
             [tooltip]="'Reports generieren'" flow="left">
          </i>
        </ng-template>
        <ng-template #contentTemplate>
          <div class="content">
            <div class="md-menu-item"
                 (click)="config.receiptTaskOpenTestReportPdf()"
                 [class.app-disabled]="!(TaskSummary?.receiptList?.data
                                         && TaskSummary.receiptList.data.length > 0
                                         && !config.receiptList.isLoading)">
              {{getRessource('ReportFileTT', {
              fileextension: 'pdf',
              entity: 'Vorgang'
            })}}
            </div>
            <div class="md-menu-item"
                 (click)="config.receiptCaseOpenTestReportPdf()"
                 [class.app-disabled]="!(TaskSummary?.receiptList?.data
                                         && TaskSummary.receiptList.data.length > 0
                                         && !config.receiptList.isLoading)">
              {{getRessource('ReportFileTT', {
              fileextension: 'pdf',
              entity: 'Auftrag'
            })}}
            </div>
          </div>
        </ng-template>
      </app-exg-dropdown>
      <i class="search-filter-seperator"></i>
    </ng-container>
  </div>
</div>
<!--Loading-->
<ng-container *ngIf="TaskSummary?.taskDetails?.isLoading">
  <div class="content md3-surface">
    <div class="splash loading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-container>


